// extracted by mini-css-extract-plugin
module.exports = {"container":"Template__container___9NPGI","message":"Template__message___PZsye","editor":"Template__editor___X5CbG"};